import React, { useCallback, useRef, useState } from "react"

interface EmailPreviewProps {
  html: string
  title: string
}

const MIN_HEIGHT = 120

// The shared rich-text sanitizer drops the inline styles, sizes and blocks the
// company frame is built from, so an email is shown in its own document as sent.
export const emailDocument = (html: string): string =>
  '<!doctype html><html><head><meta charset="utf-8">' +
  '<base target="_blank">' +
  "<style>body{margin:0;font-family:Manrope,Arial,sans-serif;font-size:14px;" +
  "color:#111827;overflow-wrap:anywhere}img{max-width:100%}</style>" +
  `</head><body>${html}</body></html>`

export const EmailPreview = ({ html, title }: EmailPreviewProps) => {
  const frameRef = useRef<HTMLIFrameElement>(null)
  const [height, setHeight] = useState(MIN_HEIGHT)

  const fit = useCallback(() => {
    const doc = frameRef.current?.contentDocument
    if (!doc?.documentElement) return
    setHeight(Math.max(MIN_HEIGHT, doc.documentElement.scrollHeight))
  }, [])

  const onLoad = useCallback(() => {
    fit()
    frameRef.current?.contentDocument
      ?.querySelectorAll("img")
      .forEach((image) => image.addEventListener("load", fit))
  }, [fit])

  return (
    <iframe
      ref={frameRef}
      title={title}
      srcDoc={emailDocument(html)}
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      onLoad={onLoad}
      className="block w-full border-0"
      style={{ height }}
    />
  )
}
